import styled from '@emotion/styled'

export const StyleUploadButtonWrapper = styled.div<any>`
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : props.theme.colors.inputBorder};
  border-radius: 6px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  overflow: hidden;
`

export const StyleUploadButton = styled.div<any>`
  background: ${(props) => props.theme.colors.primary};
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.white};
  padding: 0px 30px;
  border-radius: 6px;
  font-size: 12px;
`

export const StyleUploadInput = styled.input`
  display: none;
`

export const StyleUploadButtonImgPreview = styled.img`
  width: 50px;
  height: 40px;
  border-radius: 6px;
`

export const StyleUploadInputWrapper = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : props.theme.colors.inputBorder};
  border-radius: 6px;
  height: 40px;
  padding: 0px 10px;
`
export const StyleUploadInputFilename = styled.p<any>`
  font-size: 12px;
  color: ${(props) => props.theme.colors.placeholder};
`

export const StyleDragUploadWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${(props: any) => props.size}px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  overflow: hidden;
  position: relative;

  ${(props) => props.styleWrapper};
`

export const StyleVideoWrapper = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`
export const StyleDragImageWrapper = styled.img<any>`
  width: 100%;
  height: ${(props) => props.size}px;
  object-fit: cover;
`
export const StyleButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: center;
  width: 100%;
  justify-content: center;
`

export const StyleDragButton = styled.button`
  padding: 0px 10px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 300;
  padding: 10px 15px;
  height: auto;
  border: 0px;
  background: none;
  display: flex;
  row-gap: 10px;
  align-items: center;
  column-gap: 5px;

  color: ${(props: any) => props.theme.colors.placeholder};
`

export const StyleAvatarWrapper = styled.div<any>`
  width: ${(props: any) => props.size}px;
  height: ${(props: any) => props.size}px;
  background: ${(props: any) => props.theme.colors.secondary100};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  ${(props) => props.styleWrapper};
`

export const StyleAvatarImage = styled.img<any>`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`

export const StyleIconWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  z-index: 11;
  background: ${(props: any) => props.theme.colors.primary100};
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  right: 10px;
`

export const StyleBannerUploadWrapper = styled.div<any>`
  background: ${(props: any) => props.theme.colors.placeholder600};
  width: 100%;
  height: ${(props: any) => props.size}px;
  position: relative;
  border-radius: 8px;
`

export const StyleBannerUploadIconWrapper = styled.div<any>`
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 50%;
  padding: 5px;
  z-index: 11;
`
